module.exports = __webpack_public_path__ + "img/messaging-selected-icon.738fd1c3.svg";